import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useRouterState } from '@tanstack/react-router'

export function AppLoadingBar() {
  const { t } = useTranslation('common')
  const isRouterPending = useRouterState({
    select: state => state.status === 'pending',
  })

  const [visible, setVisible] = useState(false)
  useEffect(() => {
    if (!isRouterPending) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- syncing local visibility with the external router signal
      setVisible(false)
      return
    }
    const id = window.setTimeout(() => setVisible(true), 150)
    return () => window.clearTimeout(id)
  }, [isRouterPending])

  if (!visible) return null

  return (
    <div
      role="progressbar"
      aria-label={t('loading')}
      className="fixed inset-x-0 top-0 z-[600] h-[2px] overflow-hidden bg-[color:var(--color-brand-purple)]/15"
    >
      <span className="block h-full w-1/3 [animation:appLoadingBar_1.2s_ease-in-out_infinite] bg-[color:var(--color-brand-purple)]" />
      <style>{`
        @keyframes appLoadingBar {
          0%   { transform: translateX(-100%); }
          50%  { transform: translateX(150%); }
          100% { transform: translateX(300%); }
        }
      `}</style>
    </div>
  )
}
